/**
 * @file Progress atom — determinate progress compound family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Progress
 */
export {
  UIProgress,
  Progress,
  ProgressFilledTrack,
} from "@/components/ui/progress";
